import { loadPreferences, myPreferences, savePreferences } from '@/appLogic/view/preferences';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { TableType } from '@/coreDomainsModule/table';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * ヘッダーの表示/非表示の情報を複数まとめてDBに保存する
 */
export class BulkSaveTableHeaderHidePreferenceUseCase {
  /**
   * ヘッダーの表示/非表示の情報を複数まとめてDBに保存する
   * @param tableType - テーブルの種類
   * @param headers - 変更対象のヘッダーリスト
   * @param isHide - 非表示にするかどうか
   * @returns 失敗した時はエラーを返す
   */
  public async Execute(tableType: TableType, headers: string[], isHide: boolean): Promise<INetworkResult<void, Error>> {
    try {
      // 最新のPreferencesを取得
      await loadPreferences();
      if (!myPreferences || !Object.keys(myPreferences).includes(tableType)) {
        return {
          status: {
            type: 'error',
            error: Error('保存に失敗しました'),
          },
        };
      }
      const preference = simpleCopy(myPreferences[tableType]);

      if (isHide) {
        preference.hideHeaderList = Array.from(new Set([...preference.hideHeaderList, ...headers]));
      } else {
        preference.hideHeaderList = preference.hideHeaderList.filter((hideHeader) => !headers.includes(hideHeader));
      }

      myPreferences[tableType] = preference;
      await savePreferences();
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
